
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/offer/refer",
      function () {
        return require("private-next-pages/offer/refer/index.page.ts");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/offer/refer"])
      });
    }
  